$component-class: 'dh-navbar-type-1';

.#{$component-class} {
  position: relative;
  z-index: 1;
  background-color: $dh-background-color-primary;
  height: 72px;

  // Width + horizontal gutters (20→40) come from the shared `dh-container`
  // mixin. Only the vertical padding is navbar-specific.
  &__inner {
    @include dh-container;

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 20px;
    padding-bottom: 16px;

    @include dh-sm {
      padding-bottom: 20px;
    }
  }

  &__brand {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
  }

  &__logo {
    display: block;
    height: auto;
    max-height: 24px;
    width: auto;
  }

  &__menu {
    display: flex;
    align-items: center;
  }
}
